import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
//Iconos
//"/assets/dist/svg/main.svg#chevron-right"
// import M1 from '../../../../assets/dist/svg/main.svg';
// import { ResponsableFinanciero } from './ResponsableFinanciero';
// import { Asegurado } from './Asegurado';
// import { PersonaContacto } from './PersonaContacto';
import f1 from '../../../../assets/dist/svg/main.svg';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded';
import ReactTooltip from 'react-tooltip';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    Grid,
    List,
    ListItem,
    ListItemText,
    LinearProgress,
} from '@material-ui/core';
import {
    ObtieneDatosPersonalesLogic,
    ObtieneDatosTipoPersonaPorPostulacionLogic,
    useStyles,
} from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import { UpdateEtapaProcesoLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import { ObtieneProcesoActualLogic } from '../../../view-model/Parametros/Parametros.logic';
import { format } from 'fecha';

import IViewTipoPersona from '../../../view-interfaces/IViewTipoPersona';
import IViewTipoPersonaCmb from '../../../view-interfaces/IViewTipoPersonaCmb';

import IViewEtapas from '../../../view-interfaces/IViewEtapas';
import DatosAlumno from '../../../view-model/Modals/DatosAlumno';
import DatosResponsableFinanciero from '../../../view-model/Modals/DatosResponsableFinanciero';
import DatosResponsableLegal from '../../../view-model/Modals/DatosResponsableLegal';
import { ObtienePanelesTipoPersonaValidarLogic } from '../../../view-model/Parametros/Parametros.logic';
import IViewPanelesAlumno from '../../../view-interfaces/IViewPanelesAlumno';

import IViewDatosPersonales from '../../../view-interfaces/IViewDatosPersonales';
import IViewDatosPersonalesCmb from '../../../view-interfaces/IViewDatosPersonalesCmb';
import ContactoPopUp from '../../../view-model/Modals/Contacto';
import AseguradoPopUp from '../../../view-model/Modals/Asegurado';
import {
    ObtieneEtapasLogic,
    ObtieneSiguienteEtapaLogic,
} from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import Alert from '@material-ui/lab/Alert/Alert';
import { RequisitosRF } from '../../../view-model/Modals/RequisitosRF';
import { RequisitosRL } from '../../../view-model/Modals/RequisitosRL';
import { RequisitosAsegurado } from '../../../view-model/Modals/RequisitosAsegurado';
import { ObtieneFirmaLogic, ObtieneTieneFirmaContratoLogic } from '../../../view-model/Contrato/Contrato.logic';
import { con } from '../../../../application/entity/Rutas';
import { Alumno } from './Alumno';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

type Props = {
    rut: number;
    codigoNegocio: number;
    codCarrera: string;
    numeroAlumno: string;
    anioPromocion: number;
    periodoPromocion: number;
    onClickContinuar: any;
    onRefreshMenu: any;
};

export const MenuDatosPersonalesV2: React.FC<Props> = ({
    rut = 0,
    codigoNegocio = 0,
    codCarrera = '',
    numeroAlumno = '',
    anioPromocion = 0,
    periodoPromocion = 0,
    onClickContinuar,
    onRefreshMenu,
}) => {
    const history = useHistory();
    const location = useLocation();

    const lista: Array<IViewDatosPersonales> = [];
    const [postulante, setPostulante] = useState(lista);
    const listaCmb: Array<IViewDatosPersonalesCmb> = [];
    const [postulanteCmb, setPostulanteCmb] = useState(listaCmb);
    const [postulanteCmb2, setPostulanteCmb2] = useState(listaCmb);

    const [firma1, setFirma1] = useState(0);
    const [firma2, setFirma2] = useState(0);
    const [firmado1, setFirmado1] = useState(false);
    const [firmado2, setFirmado2] = useState(false);

    const listaRF: Array<IViewTipoPersona> = [
        {
            idPersona: 0,
            run: 0,
            dv: '',
            nombres: '',
            primerApellido: '',
            segundoApellido: '',
            fechaNacimiento: '',
            codigoComuna: 0,
            nombreComuna: '',
            direccion: '',
            telefono: 0,
            email: '',
            codSexo: 0,
            sexo: '',
            idPais: 0,
            pais: '',
            idNacionalidad: 0,
            nacionalidad: '',
            runFormato: '',
            nombreCompleto: '',
        },
    ];

    const [representanteFinanciero, setRepresentanteFinanciero] = useState(listaRF);
    const [representanteLegal, setRepresentanteLegal] = useState(listaRF);
    const listaRFCmb: Array<IViewTipoPersonaCmb> = [];
    const [rFCmb, setRFCmb] = useState(listaRFCmb);
    const [rFCmb2, setRFCmb2] = useState(listaRFCmb);
    const [rLCmb, setRLCmb] = useState(listaRFCmb);
    const [rLCmb2, setRLCmb2] = useState(listaRFCmb);

    const listAsegurado: Array<IViewTipoPersona> = [
        {
            idPersona: 0,
            run: 0,
            dv: '',
            nombres: '',
            primerApellido: '',
            segundoApellido: '',
            fechaNacimiento: '',
            codigoComuna: 0,
            nombreComuna: '',
            direccion: '',
            telefono: 0,
            email: '',
            codSexo: 0,
            sexo: '',
            idPais: 0,
            pais: '',
            idNacionalidad: 0,
            nacionalidad: '',
            runFormato: '',
            nombreCompleto: '',
        },
    ];
    const [listaAsegurado, setListaAsegurado] = useState(listAsegurado);
    const listAseguradoCmb: Array<IViewTipoPersonaCmb> = [];
    const [aseguradoCmb, setAseguradoCombo] = useState(listAseguradoCmb);
    const [aseguradoCmb2, setAseguradoCombo2] = useState(listAseguradoCmb);

    const [openModalDatosAlumno, setOpenModalDatosAlumno] = useState(false);
    const [openModalReprFinan, setOpenModalReprFinan] = useState(false);
    const [openModalReprLeg, setOpenModalReprLeg] = useState(false);
    const [openModalAsegurado, setOpenModalAsegurado] = useState(false);
    const [openModalContacto, setOpenModalContacto] = useState(false);
    const [loading, setLoading] = useState(false);

    const [actualizarDebeFirmar, setActualizarDebeFirmar] = useState(false);
    const [sigEtapa, setSigEtapa] = useState('');

    const listContacto: Array<IViewTipoPersona> = [
        {
            idPersona: 0,
            run: 0,
            dv: '',
            nombres: '',
            primerApellido: '',
            segundoApellido: '',
            fechaNacimiento: '',
            codigoComuna: 0,
            nombreComuna: '',
            direccion: '',
            telefono: 0,
            email: '',
            codSexo: 0,
            sexo: '',
            idPais: 0,
            pais: '',
            idNacionalidad: 0,
            nacionalidad: '',
            runFormato: '',
            nombreCompleto: '',
        },
    ];
    const [listaContacto, setListaContacto] = useState(listContacto);
    const listContactoCmb: Array<IViewTipoPersonaCmb> = [];
    const [contactoCmb, setContactoCmb] = useState(listContactoCmb);
    const [contactoCmb2, setContactoCmb2] = useState(listContactoCmb);

    const listaPaneles: Array<IViewPanelesAlumno> = [];
    const [paneles, setPaneles] = useState(listaPaneles);
    const [panelAlumno, setPanelAlumno] = useState(false);
    const [panelRF, setPanelRF] = useState(false);
    const [panelAsegurado, setPanelAsegurado] = useState(false);
    const [panelPC, setPanelPC] = useState(false);

    const [validadoAlum, setValidadoAlum] = useState(false);
    const [validadoRF, setValidadoRF] = useState(false);
    const [validadoRL, setValidadoRL] = useState(false);
    const [validadoAseg, setValidadoAseg] = useState(false);
    const [validadoCont, setValidadoCont] = useState(false);
    const [idProcesoPostulante, setIdProcesoPostulante] = useState(0);
    const [validado, setValidado] = useState(false);

    const [anioPromocionParametro, setAnioPromocionParametro] = useState(0);
    const [periodoPromocionParametro, setPeriodoPromocionParametro] = useState(0);
    const [nombreAlumnoParametro, setNombreAlumnoParametro] = useState('');

    const [numeroAlumnoParametro, setNumeroAlumnoParametro] = useState('');
    const [codigoPlanificacionAcademicaParametro, setCodigoPlanificacionAcademicaParametro] = useState(0);
    const [nombreCarreraParametro, setNombreCarreraParametro] = useState('');
    const [sedeParametro, setSedeParametro] = useState(0);
    const [esMenorEdadParametro, setEsMenorEdadParametro] = useState(false);

    const [cargando_datos, setCargando_datos] = useState(true);
    const [cargando_datosAlum, setCargando_datosAlum] = useState(true);
    const [cargando_datosRF, setCargando_datosRF] = useState(true);
    const [cargando_datosRL, setCargando_datosRL] = useState(true);
    const [cargando_datosAse, setCargando_datosAse] = useState(true);
    const [cargando_datosCont, setCargando_datosCont] = useState(true);

    const listaEtapas: Array<IViewEtapas> = [];
    const [etapas, setEtapas] = useState(listaEtapas);

    const [periodoActual, setPeriodoActual] = useState(0);

    const [alumnoNuevo, setAlumnoNuevo] = useState(false);
    const [instrucciones1, setInstrucciones1] = useState('');
    const [instrucciones2, setInstrucciones2] = useState('');
    const [instrucciones3, setInstrucciones3] = useState('');

    const [openModalRequisitosRF, setOpenModalRequisitosRF] = useState(false);
    const [openModalRequisitosRL, setOpenModalRequisitosRL] = useState(false);
    const [openModalRequisitos, setOpenModalRequisitos] = useState(false);

    const [error, setError] = useState(false);
    const [reintentar, setReintentar] = useState(false);

    const [esCarrera, setEsCarrera] = useState(false);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    const [codNegocio, setCodNegocio] = useState(0)
    useEffect(() => {
        if (reintentar) {
            setError(false);
            if (location.state === null || location.state === undefined) {
                history.push({
                    pathname: '/Inicio',
                });
            } else {
                handleCargaDatosIniciales();
            }
            setReintentar(false);
        }
    }, [reintentar]);

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: '/Inicio',
            });
        } else {
            handleCargaDatosIniciales();
        }
    }, []);

    const handleCargaDatosIniciales = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        console.log('PARAM MENU PERSONALES');
        console.log(_params);
        setCodNegocio(_params.headers.codNegocio)
        setIdProcesoPostulante(Number(_params.idProceso));

        let carreras = con.carrerasMensajeriaRF();
        let _esCarrera = false;
        carreras.map((e: any) => {
            if (e === _params.codCarrera) {
                if (!_esCarrera) {
                    _esCarrera = true;
                }
            }
        });
        setEsCarrera(_esCarrera);
        setCodigoPlanificacionAcademicaParametro(_params.codigoPlanificacionAcademica);
        setSedeParametro(_params.codsede);
        setNombreAlumnoParametro(_params.nombreAlumno);
        setNombreCarreraParametro(_params.nombreCarrera);
        setNumeroAlumnoParametro(_params.numeroAlumno);
        setAnioPromocionParametro(_params.anioPromocion);
        setPeriodoPromocionParametro(_params.periodoPromocion);
        setAlumnoNuevo(_params.numeroAlumno);
        ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, _params.idProceso, idPeriodo);
        ObtieneEtapasLogic(
            selListaEtapas,
            _params.codigoNegocio,
            _params.codCarrera,
            _params.codigoPlanificacionAcademica,
            _params.rut,
            _params.anioPromocion,
            _params.periodoPromocion,
        );
        ObtieneProcesoActualLogic(selListaProcesoActual);
    };

    const selObtenerFirma = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                // aquí
                /* console.log(Resultado) */
                setFirma1(Resultado[0].idTipoPersona);
                setFirmado1(Resultado[0].contratoFirmado);
                if (Resultado[1] !== undefined) {
                    setFirma2(Resultado[1].idTipoPersona);
                    setFirmado2(Resultado[1].contratoFirmado);
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    };

    useEffect(() => {
        setInstrucciones1(
            ' Por favor revisar datos personales del Alumno y actualizar los que correspondan. Si el nombre del postulante/alumno tiene un error, por favor enviar copia de cédula de identidad a matriculaweb_scl@udd.cl para Sede Santiago o matriculaweb_ccp@udd.cl para Sede Concepción según corresponda indicando la solicitud del cambio.',
        );
        setInstrucciones2(
            ' Completar datos del Responsable Financiero. Si el Responsable Financiero cumple con los requisitos para ser el asegurado, se autocompletarán los datos, de lo contrario deberá ingresar un asegurado distinto al Responsable Financiero.',
        );
        setInstrucciones3(' Completar datos persona de contacto.');
    }, [alumnoNuevo]);

    const selListaProcesoActual = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                /* console.log(data.ano)    */
                setPeriodoActual(parseInt(data.ano));
            }
        } catch (err) {
            console.log('error', err);
        }
    };

    const selListaEtapas = (error: Boolean, err: string, Etapas: any) => {
        if (error === false && Etapas !== undefined) {
            setEtapas(Etapas);
            Etapas.map((e: any) => {
                if (e.idEtapa === 1) {
                    setValidado(e.estado);
                }
            });
        }
    };

    useEffect(() => {
        if (etapas.length > 0) {
            siguienteEtapa();
        }
    }, [etapas]);

    useEffect(() => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);

        if (validadoAlum && validadoRF && !_params.debeFirmar) {
            ObtieneTieneFirmaContratoLogic(
                selListaFirma,
                _params.codigoNegocio,
                _params.rut,
                _params.codCarrera,
                _params.anioPromocion,
                _params.periodoPromocion,
                _params.codigoPlanificacionAcademica,
            );
        }
    }, [validadoAlum, validadoRF, validadoRL, validadoCont, validadoAseg]);

    const selListaFirma = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            console.log('MENU_DATOS_PERSONALES resultado firmar');
            console.log(data);

            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (data === true) {
                setActualizarDebeFirmar(true);
                _params.debeFirmar = true;
                onRefreshMenu(true);
            }
        }
    };

    const selListaPostulante = (error: Boolean, err: string, Estudiante: any) => {
        try {
            if (error === false && Estudiante[0].run.toString().trim().length > 1) {
                let _postulante: Array<IViewDatosPersonales> = [];
                let _cmb: Array<IViewDatosPersonalesCmb> = [];
                let _cmb2: Array<IViewDatosPersonalesCmb> = [];
                _cmb.push({
                    ID: 1,
                    Descripcion: 'RUT: ' + Estudiante[0].runFormato.trim(),
                });
                _cmb.push({
                    ID: 2,
                    Descripcion: 'NOMBRE COMPLETO: ' + Estudiante[0].nombreCompleto.trim(),
                });
                _cmb.push({
                    ID: 3,
                    Descripcion:
                        'FECHA DE NACIMIENTO: ' +
                        (format(new Date(Estudiante[0].fechaNacimiento), 'DD-MM-YYYY') === '01-01-1900'
                            ? ''
                            : format(new Date(Estudiante[0].fechaNacimiento), 'DD-MM-YYYY')),
                });
                _cmb.push({
                    ID: 4,
                    Descripcion: 'NACIONALIDAD: ' + Estudiante[0].nacionalidad.trim(),
                });
                _cmb.push({
                    ID: 5,
                    Descripcion: 'SEXO: ' + Estudiante[0].sexo.trim(),
                });

                _cmb2.push({
                    ID: 1,
                    Descripcion: 'DIRECCIÓN: ' + Estudiante[0].direccion.trim(),
                });
                _cmb2.push({
                    ID: 2,
                    Descripcion: 'COMUNA: ' + Estudiante[0].nombreComuna.trim(),
                });
                _cmb2.push({
                    ID: 3,
                    Descripcion: 'TELÉFONO: +56' + Estudiante[0].telefono.toString(),
                });
                _cmb2.push({
                    ID: 4,
                    Descripcion: 'EMAIL: ' + Estudiante[0].email.trim(),
                });

                setPostulanteCmb(_cmb);
                setPostulanteCmb2(_cmb2);

                _postulante.push({
                    idPersona: Estudiante[0].idPersona,
                    run: Estudiante[0].run,
                    dv: Estudiante[0].dv.trim(),
                    pasaporte: Estudiante[0].pasaporte.trim(),
                    nombres: Estudiante[0].nombres.trim(),
                    primerApellido: Estudiante[0].primerApellido.trim(),
                    segundoApellido: Estudiante[0].segundoApellido.trim(),
                    fechaNacimiento: Estudiante[0].fechaNacimiento, //format(new Date(Estudiante[0].fechaNacimiento), 'YYYY-MM-DD'),
                    esMenorEdad: Estudiante[0].esMenorEdad,
                    codigoComuna: Estudiante[0].codigoComuna,
                    nombreComuna: Estudiante[0].nombreComuna.trim(),
                    direccion: Estudiante[0].direccion.trim(),
                    telefono: Estudiante[0].telefono,
                    email: Estudiante[0].email.trim(),
                    emailUDD: Estudiante[0].emailUDD.trim(),
                    codSexo: Estudiante[0].codSexo,
                    sexo: Estudiante[0].sexo.trim(),
                    idPais: Estudiante[0].idPais,
                    pais: Estudiante[0].pais.trim(),
                    idNacionalidad: Estudiante[0].idNacionalidad,
                    nacionalidad: Estudiante[0].nacionalidad.trim(),
                    runFormato: Estudiante[0].runFormato.trim(),
                    nombreCompleto: Estudiante[0].nombreCompleto.trim(),
                });
                //console.log(_postulante)
                setPostulante(_postulante);
                setEsMenorEdadParametro(Estudiante[0].esMenorEdad);
                setCargando_datos(false);
                setCargando_datosAlum(false);

                if (Estudiante[0].esMenorEdad && codigoNegocio === 1) {
                    let _tt = JSON.stringify(location.state);
                    let _params = JSON.parse(_tt);

                    ObtieneDatosTipoPersonaPorPostulacionLogic(
                        selListaRepresentanteLegal,
                        _params.headers,
                        _params.rut,
                        _params.codigoNegocio,
                        _params.codCarrera,
                        _params.anioPromocion,
                        _params.periodoPromocion,
                        0,
                        5,
                        _params.idPeriodo,
                    );
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const UpdateEtapaProceso = () => {
        UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 1);
    };

    const selUpdateEtapa = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            /* console.log(data) */
            /* onClickContinuar(sigEtapa) */
            onClickContinuar('3');
        }
    };

    const selListaRepresentanteFinanciero = (
        error: Boolean,
        err: string,
        list: Array<IViewTipoPersona>,
        _list: Array<IViewTipoPersonaCmb>,
        _list2: Array<IViewTipoPersonaCmb>,
    ) => {
        try {
            if (error === false && list.length > 0 && _list.length > 0 && _list2.length > 0) {
                /* console.log(list) */
                setRepresentanteFinanciero(list);
                setRFCmb(_list);
                setRFCmb2(_list2);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
        setCargando_datosRF(false);
    };

    const selListaRepresentanteLegal = (
        error: Boolean,
        err: string,
        list: Array<IViewTipoPersona>,
        _list: Array<IViewTipoPersonaCmb>,
        _list2: Array<IViewTipoPersonaCmb>,
    ) => {
        try {
            if (error === false && list.length > 0 && _list.length > 0 && _list2.length > 0) {
                /* console.log(list) */
                setRepresentanteLegal(list);
                setRLCmb(_list);
                setRLCmb2(_list2);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
        setCargando_datosRL(false);
    };

    const selListaAsegurado = (
        error: Boolean,
        err: string,
        list: Array<IViewTipoPersona>,
        _list: Array<IViewTipoPersonaCmb>,
        _list2: Array<IViewTipoPersonaCmb>,
    ) => {
        try {
            if (error === false && list.length > 0 && _list.length > 0 && _list2.length > 0) {
                /* console.log(list) */
                setListaAsegurado(list);
                setAseguradoCombo(_list);
                setAseguradoCombo2(_list2);
                /* console.log(anoParametro === periodoActual) */
                if (anioPromocionParametro === periodoActual) {
                    if (representanteFinanciero[0].run === listaAsegurado[0].run) {
                        if (
                            calcularAños(listaAsegurado[0].fechaNacimiento) < /* 65 */ 75 &&
                            calcularAños(listaAsegurado[0].fechaNacimiento) > 17
                        ) {
                            setValidadoAseg(validadoRF);
                        }
                    }
                } else {
                    if (representanteFinanciero[0].run === listaAsegurado[0].run) {
                        setValidadoAseg(validadoRF);
                    }
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
        setCargando_datosAse(false);
    };

    const selListaContacto = (
        error: Boolean,
        err: string,
        list: Array<IViewTipoPersona>,
        _list: Array<IViewTipoPersonaCmb>,
        _list2: Array<IViewTipoPersonaCmb>,
    ) => {
        try {
            if (error === false && list.length > 0 && _list.length > 0 && _list2.length > 0) {
                setListaContacto(list);
                setContactoCmb(_list);
                setContactoCmb2(_list2);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
        setCargando_datosCont(false);
    };

    const handleDatosAlumno = () => {
        setOpenModalDatosAlumno(true);
    };

    const handleDatosRepresentanteFinanciero = () => {
        setOpenModalReprFinan(true);
    };

    const handleDatosRepresentanteLegal = () => {
        setOpenModalReprLeg(true);
    };

    const handleAsegurado = () => {
        setOpenModalAsegurado(true);
    };

    const handleContacto = () => {
        setOpenModalContacto(true);
    };

    const handleCerrarPopupDA = (paso: boolean = false, guardado: boolean = false) => {
        setValidadoAlum(guardado);
        if (representanteFinanciero[0].run === postulante[0].run) {
            setValidadoRF(guardado);
        }

        setOpenModalDatosAlumno(false);
        ObtienePanelesTipoPersonaValidarLogic(selListaPaneles, codigoNegocio);
    };

    const handleCerrarPopupDRF = (paso: Boolean = false, guardado: boolean = false) => {
        if (cargando_datosRF !== guardado) {
            setCargando_datosAlum(true);
            setCargando_datosRF(true);
            setCargando_datosCont(true);
            setCargando_datosAse(true);
        }
        setValidadoRF(guardado);

        if (anioPromocionParametro === periodoActual) {
            if (representanteFinanciero[0].run === listaAsegurado[0].run) {
                /* 65 */
                if (
                    calcularAños(listaAsegurado[0].fechaNacimiento) < 75 &&
                    calcularAños(listaAsegurado[0].fechaNacimiento) > 17
                ) {
                    setValidadoAseg(guardado);
                }
            }
        } else {
            if (representanteFinanciero[0].run === listaAsegurado[0].run) {
                setValidadoAseg(guardado);
            }
        }

        setOpenModalReprFinan(false);
    };

    const handleCerrarPopupDRL = (paso: Boolean = false, guardado: boolean = false) => {
        if (cargando_datosRL !== guardado) {
            setCargando_datosRL(true);
        }
        setValidadoRL(guardado);

        if (anioPromocionParametro === periodoActual) {
            if (representanteLegal[0].run === listaAsegurado[0].run) {
                if (
                    calcularAños(listaAsegurado[0].fechaNacimiento) < 75 &&
                    calcularAños(listaAsegurado[0].fechaNacimiento) > 17
                ) {
                    setValidadoAseg(guardado);
                }
            }
        } else {
            if (representanteLegal[0].run === listaAsegurado[0].run) {
                setValidadoAseg(guardado);
            }
        }

        setOpenModalReprLeg(false);
    };

    const handleCerrarPopupAsegurado = (paso: Boolean = false, guardado: boolean = false) => {
        if (cargando_datosAse !== guardado) {
            setCargando_datosAlum(true);
            setCargando_datosRF(true);
            setCargando_datosCont(true);
            setCargando_datosAse(true);
        }
        setValidadoAseg(guardado);

        setOpenModalAsegurado(false);
    };

    const handleCerrarPopupContacto = (paso: Boolean = false, guardado: boolean = false) => {
        if (cargando_datosCont !== guardado) {
            setCargando_datosAlum(true);
            setCargando_datosRF(true);
            setCargando_datosCont(true);
            setCargando_datosAse(true);
        }
        setValidadoCont(guardado);

        setOpenModalContacto(false);
    };

    const selListaPaneles = (error: Boolean, err: string, list: Array<IViewPanelesAlumno>) => {
        try {
            if (error === false && list.length > 0) {
                //  let _panel = list.find(_panel => _panel.descripcionTipo === 'Alumnos')
                //  console.log('_panel', _panel)
                for (let I = 0; I < list.length; I++) {
                    switch (list[I].idTipoPersona) {
                        case 1:
                            setPanelAlumno(list[I].estado);
                            break;
                        case 2:
                            setPanelRF(list[I].estado);
                            break;
                        case 3:
                            setPanelAsegurado(list[I].estado);
                            break;
                        case 4:
                            setPanelPC(list[I].estado);
                            break;
                        default:
                            break;
                    }
                }
                setPaneles(list);
            }
        } catch (er) {
            console.log('error', er);
        }
    };

    const handlePaneles = () => {
        ObtienePanelesTipoPersonaValidarLogic(selListaPaneles, codigoNegocio);
    };

    useEffect(() => {
        setLoading(true);
        handlePaneles();
        setTimeout(() => {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            console.log(_params)
            if (_params.pasaporte === "" || _params.pasaporte === undefined || _params.pasaporte === null) {
                ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, rut, '', codigoNegocio, 1, _params.idPeriodo);
            } else {
                ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, 0, _params.pasaporte, codigoNegocio, 1, _params.idPeriodo);
            }

            console.log('DEC REPRESENTANTE FINANZAS');
            console.log(codigoPlanificacionAcademicaParametro);


            ObtieneDatosTipoPersonaPorPostulacionLogic(
                selListaRepresentanteFinanciero,
                _params.headers,
                _params.rut,
                _params.codigoNegocio,
                _params.codCarrera,
                _params.anioPromocion,
                _params.periodoPromocion,
                0,
                2,
                _params.idPeriodo
            );

            if (codigoNegocio === 1) {
                ObtieneDatosTipoPersonaPorPostulacionLogic(
                    selListaAsegurado,
                    _params.headers,
                    _params.rut,
                    _params.codigoNegocio,
                    _params.codCarrera,
                    _params.anioPromocion,
                    _params.periodoPromocion,
                    0,
                    3,
                    _params.idPeriodo,
                );
                ObtieneDatosTipoPersonaPorPostulacionLogic(
                    selListaContacto,
                    _params.headers,
                    _params.rut,
                    _params.codigoNegocio,
                    _params.codCarrera,
                    _params.anioPromocion,
                    _params.periodoPromocion,
                    0,
                    4,
                    _params.idPeriodo
                );
            }
        }, 4000);

        setLoading(false);
    }, [rut, openModalDatosAlumno, openModalAsegurado, openModalContacto, openModalReprFinan, openModalReprLeg]);

    useEffect(() => {
        setLoading(true);

        setLoading(false);
    }, [openModalDatosAlumno]);

    function calcularAños(fecha: string) {
        /*  var today = new Date();
         var birthday = new Date(fechaNacimiento);
         //Restamos los años
         let agno = today.getFullYear() - birthday.getFullYear();
         // Si no ha llegado su cumpleaños le restamos el año por cumplir
         if (birthday.getMonth() > today.getMonth() || (birthday.getDay() > today.getDay() && birthday.getMonth() === today.getMonth()))
             agno--; */
        /* console.log(fecha) */
        let hoy = new Date();
        let birthday = new Date(fecha);
        /* console.log(hoy)
        console.log(birthday) */
        let agno = hoy.getFullYear() - birthday.getFullYear();
        let diferenciaMeses = hoy.getMonth() - birthday.getMonth();
        if (diferenciaMeses < 0 || (diferenciaMeses === 0 && hoy.getDate() < birthday.getDate())) {
            agno--;
        }
        /* console.log(agno) */
        return agno;
    }

    const siguienteEtapa = () => {
        var contrato: boolean = false;
        var pago: boolean = false;
        /* console.log(etapas) */
        etapas.map((e: IViewEtapas) => {
            if (e.nombre === 'Pago Web-Pay') {
                pago = e.estado;
            }
            if (e.nombre === 'Contrato') {
                contrato = e.estado;
            }
        });

        ObtieneSiguienteEtapaLogic(selSiguienteEtapa, contrato, !pago);
    };
    const selSiguienteEtapa = (error: Boolean, err: string, Sig: any) => {
        if (error === false && Sig !== undefined) {
            setSigEtapa(Sig.idEtapa.toString());
        }
    };

    const handleRequisitos = () => {
        setOpenModalRequisitos(true);
    };
    const handleRequisitosRF = () => {
        setOpenModalRequisitosRF(true);
    };
    const handleRequisitosRL = () => {
        setOpenModalRequisitosRL(true);
    };
    const handleCerrarPopUpRequisitos = (paso: Boolean = false) => {
        if (paso) {
        }
        setOpenModalRequisitos(false);
    };
    const handleCerrarPopUpRequisitosRF = (paso: Boolean = false) => {
        if (paso) {
        }
        setOpenModalRequisitosRF(false);
    };
    const handleCerrarPopUpRequisitosRL = (paso: Boolean = false) => {
        if (paso) {
        }
        setOpenModalRequisitosRL(false);
    };
    const classes = useStyles();
    return (
        <>
            {error ? (
                <div className="site-main__container">
                    <div className="enrollment__title">Datos Personales</div>
                    <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                        <div className="enrollment__subtitle"></div>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: 100 }}>
                        <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                        <br />
                        <a>
                            <span>
                                Ocurrió un problema al obtener tus Datos Personales, favor comunicarse con la
                                universidad.
                            </span>
                        </a>
                        <br />
                        <Button
                            style={{ border: '1px solid gray' }}
                            onClick={() => setReintentar(true)}
                            color="inherit"
                        >
                            Reintentar cargar Datos Personales
                        </Button>
                    </div>
                </div>
            ) : (
                <main className="site-main enrollment">
                    <div className="site-main__container">
                        <div style={{ marginTop: '-3rem', marginBottom: '1rem' }}>
                            {
                                //codigoNegocioParametro === 1 ?
                                codigoNegocio === 1 ? (
                                    <div style={{ fontSize: '1rem' }}>
                                        {/* <div style={{ display: 'list-item' }} className="enrollment__subtitle"><strong>Si eres menor de edad (menor de 18 años) debes ir presencialmente a realizar tu proceso de Matrícula de lunes a viernes entre las 8 y las 18 hrs.</strong></div> */}
                                        <div style={{ display: 'list-item' }} className="enrollment__subtitle">
                                            Por favor revisar datos personales del Alumno y actualizar los que
                                            correspondan. Si el nombre del postulante/alumno tiene un error, por favor
                                            comunicarse a través del formulario de atención:{' '}
                                            <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/">
                                                <u>https://contacto.udd.cl/</u>
                                            </a>
                                            .
                                        </div>
                                        <div style={{ display: 'list-item' }} className="enrollment__subtitle">
                                            {instrucciones2}
                                        </div>
                                        <div style={{ display: 'list-item' }} className="enrollment__subtitle">
                                            {instrucciones3}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ fontSize: '1rem' }}>
                                        <div style={{ display: 'list-item' }} className="enrollment__subtitle">
                                            Revisar datos personales, si encuentra algún error comunicarse a través del
                                            formulario de atención:{' '}
                                            <a
                                                style={{ fontWeight: 'bold' }}
                                                href="https://contacto.udd.cl/"
                                                target="_blank"
                                            >
                                                <u>Formulario Contacto UDD</u>
                                            </a>
                                            .
                                        </div>
                                        {/* <div style={{ display: 'list-item' }} className="enrollment__subtitle">Por favor revisar datos personales, si tiene un error, por favor comunicarse a través del formulario de atención: <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/" target="_blank"><u>Formulario contacto UDD</u></a>.</div> */}
                                    </div>
                                )
                            }
                        </div>
                        {!cargando_datos ? (
                            <div>
                                <div className={classes.root}>
                                    <Grid container spacing={3}>
                                        {/* <Grid container item xs={9} direction="column" justifyContent="center" alignItems="stretch"> */}
                                        {loading && <CircularProgress size={40} className={classes.buttonProgress} />}
                                        {/* </Grid> */}
                                        {/* Se que se ve feo....pero hay que cambiar por paneles para que se vea mas bonito */}

                                        {panelAlumno ? (
                                            <>
                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    <Card elevation={0}>
                                                        <div>
                                                            <b>
                                                                <span style={{ fontSize: 24 }}>Alumno</span>
                                                            </b>
                                                            &nbsp;&nbsp;&nbsp;
                                                            {(validado || validadoAlum) && !cargando_datosAlum ? (
                                                                <CheckCircleOutline
                                                                    style={{ color: '#0062a1', fontSize: 30 }}
                                                                />
                                                            ) : (
                                                                ''
                                                            )}
                                                            {!cargando_datosAlum ? (
                                                                <CardContent>
                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        justifyContent="center"
                                                                        alignItems="stretch"
                                                                    >
                                                                        <Grid item xs={12} sm={6} md={6}>
                                                                            <div className={classes.demo}>
                                                                                <List dense>
                                                                                    {postulanteCmb.map((value) => {
                                                                                        const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                        if (
                                                                                            value.Descripcion.split(
                                                                                                ':',
                                                                                            )[0] !== 'NACIONALIDAD' &&
                                                                                            value.Descripcion.split(
                                                                                                ':',
                                                                                            )[0] !== 'SEXO'
                                                                                        ) {
                                                                                            return (
                                                                                                <ListItem key={labelId}>
                                                                                                    <div>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[0]
                                                                                                            }
                                                                                                        </p>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginTop:
                                                                                                                    -15,
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[1]
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                    {/* <ListItemText id={labelId} primary={value.Descripcion.split(':')[0]} secondary={value.Descripcion.split(':')[1]} /> */}
                                                                                                </ListItem>
                                                                                            );
                                                                                        }
                                                                                    })}
                                                                                </List>
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={6} md={6}>
                                                                            <div className={classes.demo}>
                                                                                <List dense>
                                                                                    {postulanteCmb2.map((value) => {
                                                                                        const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                        if (
                                                                                            value.Descripcion.split(
                                                                                                ':',
                                                                                            )[0] !== 'COMUNA' &&
                                                                                            value.Descripcion.split(
                                                                                                ':',
                                                                                            )[0] !== 'TELÉFONO'
                                                                                        ) {
                                                                                            return (
                                                                                                <ListItem key={labelId}>
                                                                                                    <div>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[0]
                                                                                                            }
                                                                                                        </p>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginTop:
                                                                                                                    -15,
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[1]
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                    {/* <ListItemText id={labelId} primary={value.Descripcion.split(':')[0]} secondary={value.Descripcion.split(':')[1]} /> */}
                                                                                                </ListItem>
                                                                                            );
                                                                                        }
                                                                                    })}
                                                                                </List>
                                                                            </div>
                                                                        </Grid>
                                                                    </Grid>
                                                                </CardContent>
                                                            ) : (
                                                                <div style={{ textAlign: 'center', marginTop: 100 }}>
                                                                    <CircularProgress disableShrink />
                                                                    <br />
                                                                    <a>
                                                                        <span>Cargando datos Alumno</span>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {
                                                            //codigoNegocioParametro === 1 ?
                                                            codigoNegocio === 1 ? (
                                                                <CardActions>
                                                                    {firmado1 || firmado2 ? (
                                                                        <p
                                                                            style={{ marginTop: 10 }}
                                                                            data-type={'light'}
                                                                            data-tip={
                                                                                'No se pueden realizar cambios en Alumno porque ya se firmó contrato'
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    padding: '6px 20px 6px 20px',
                                                                                    fontSize: '1rem',
                                                                                    backgroundColor: 'rgb(173 172 172)',
                                                                                    color: 'rgb(255 255 255)',
                                                                                }}
                                                                                disabled={true}
                                                                                onClick={handleDatosAlumno}
                                                                            >
                                                                                Revisar
                                                                            </Button>
                                                                            <ReactTooltip />
                                                                        </p>
                                                                    ) : (
                                                                        <Button
                                                                            variant="contained"
                                                                            style={{
                                                                                padding: '6px 20px 6px 20px',
                                                                                fontSize: '1rem',
                                                                                backgroundColor: '#0062a1',
                                                                                color: 'White',
                                                                            }}
                                                                            onClick={handleDatosAlumno}
                                                                        >
                                                                            Revisar
                                                                        </Button>
                                                                    )}
                                                                </CardActions>
                                                            ) : (
                                                                ''
                                                            )
                                                        }
                                                    </Card>
                                                </Grid>
                                                <Grid
                                                    container
                                                    item
                                                    xs={3}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    &nbsp;
                                                    <DatosAlumno
                                                        estado={openModalDatosAlumno}
                                                        onClick={handleCerrarPopupDA}
                                                        alumno={postulante}
                                                        codigoNegocio={codigoNegocio}
                                                        carrera={codCarrera}
                                                        anioPromocion={anioPromocionParametro}
                                                        periodoPromocion={periodoPromocionParametro}
                                                        validado_={validadoAlum}
                                                    />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {panelRF && representanteFinanciero[0].run !== postulante[0].run ? (
                                            <>
                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    <Card elevation={0}>
                                                        <div>
                                                            <b>
                                                                <span style={{ fontSize: 24 }}>
                                                                    Responsable Financiero
                                                                </span>
                                                            </b>
                                                            &nbsp;&nbsp;&nbsp;
                                                            {(validado || validadoRF) && !cargando_datosRF ? (
                                                                <CheckCircleOutline
                                                                    style={{ color: '#0062a1', fontSize: 30 }}
                                                                />
                                                            ) : (
                                                                ''
                                                            )}
                                                            <div style={{ color: 'gray', fontSize: '1rem' }}>
                                                                {esCarrera && numeroAlumnoParametro !== '' ? (
                                                                    <div className="enrollment__subtitle">
                                                                        Si el alumno es también el responsable
                                                                        financiero, por favor acercarce a la Univeridad
                                                                        a realizar proceso de matrícula de manera
                                                                        presencial o bien comunicarse a través del
                                                                        formulario de atención:{' '}
                                                                        <a
                                                                            style={{ fontWeight: 'bold' }}
                                                                            href="https://contacto.udd.cl/"
                                                                        >
                                                                            <u>https://contacto.udd.cl/</u>
                                                                        </a>
                                                                        &nbsp;&nbsp;
                                                                        <button
                                                                            style={{ fontSize: '1rem' }}
                                                                            type="button"
                                                                            className="btn btn-link"
                                                                            onClick={handleRequisitosRF}
                                                                        >
                                                                            Ver requisitos
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="enrollment__subtitle">
                                                                        Es quien firma junto con el alumno el Contrato
                                                                        de Prestación de Servicios Educacionales y se
                                                                        obliga, entre otras, a cumplir con las
                                                                        obligaciones económicas contraídas con la
                                                                        Universidad.&nbsp;&nbsp;
                                                                        <button
                                                                            style={{ fontSize: '1rem' }}
                                                                            type="button"
                                                                            className="btn btn-link"
                                                                            onClick={handleRequisitosRF}
                                                                        >
                                                                            Ver requisitos
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {!cargando_datosRF ? (
                                                                representanteFinanciero[0].run === 0 ? (
                                                                    ''
                                                                ) : (
                                                                    <CardContent>
                                                                        <Grid container>
                                                                            <Grid item xs={12} sm={6} md={6}>
                                                                                <div className={classes.demo}>
                                                                                    <List dense>
                                                                                        {rFCmb.map((value) => {
                                                                                            const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                            if (
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !==
                                                                                                'NACIONALIDAD' &&
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !== 'SEXO'
                                                                                            ) {
                                                                                                return (
                                                                                                    <ListItem
                                                                                                        key={labelId}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[0]
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    marginTop:
                                                                                                                        -15,
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[1]
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </ListItem>
                                                                                                );
                                                                                            }
                                                                                        })}
                                                                                    </List>
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6} md={6}>
                                                                                <div className={classes.demo}>
                                                                                    <List dense>
                                                                                        {rFCmb2.map((value) => {
                                                                                            const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                            if (
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !== 'COMUNA' &&
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !== 'TELÉFONO'
                                                                                            ) {
                                                                                                return (
                                                                                                    <ListItem
                                                                                                        key={labelId}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[0]
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    marginTop:
                                                                                                                        -15,
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[1]
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </ListItem>
                                                                                                );
                                                                                            }
                                                                                        })}
                                                                                    </List>
                                                                                </div>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </CardContent>
                                                                )
                                                            ) : (
                                                                <div style={{ textAlign: 'center', marginTop: 100 }}>
                                                                    <CircularProgress disableShrink />
                                                                    <br />
                                                                    <a>
                                                                        <span>
                                                                            Cargando datos Responsable Financiero
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {
                                                            //codigoNegocioParametro === 1 validadoRF?
                                                            codigoNegocio === 1 ? (
                                                                <CardActions>
                                                                    {validadoAlum || validado ? (
                                                                        firmado1 || firmado2 ? (
                                                                            <p
                                                                                style={{ marginTop: 10 }}
                                                                                data-type={'light'}
                                                                                data-tip={
                                                                                    'No se pueden realizar cambios en Resp. Financiero porque ya se firmó contrato.'
                                                                                }
                                                                            >
                                                                                <Button
                                                                                    variant="contained"
                                                                                    style={{
                                                                                        padding: '6px 20px 6px 20px',
                                                                                        fontSize: '1rem',
                                                                                        backgroundColor:
                                                                                            'rgb(173 172 172)',
                                                                                        color: 'rgb(255 255 255)',
                                                                                    }}
                                                                                    disabled={true}
                                                                                    onClick={
                                                                                        handleDatosRepresentanteFinanciero
                                                                                    }
                                                                                >
                                                                                    Revisar
                                                                                </Button>
                                                                                <ReactTooltip />
                                                                            </p>
                                                                        ) : (
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    padding: '6px 20px 6px 20px',
                                                                                    fontSize: '1rem',
                                                                                    backgroundColor: '#0062a1',
                                                                                    color: 'White',
                                                                                }}
                                                                                onClick={
                                                                                    handleDatosRepresentanteFinanciero
                                                                                }
                                                                            >
                                                                                Revisar
                                                                            </Button>
                                                                        )
                                                                    ) : (
                                                                        <p
                                                                            style={{ marginTop: 10 }}
                                                                            data-type={'light'}
                                                                            data-tip={
                                                                                'No se pueden guarar el Resp. Financiero porque primero debe guardar el Alumno.'
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    padding: '6px 20px 6px 20px',
                                                                                    fontSize: '1rem',
                                                                                    backgroundColor: 'rgb(173 172 172)',
                                                                                    color: 'rgb(255 255 255)',
                                                                                }}
                                                                                disabled={true}
                                                                                onClick={
                                                                                    handleDatosRepresentanteFinanciero
                                                                                }
                                                                            >
                                                                                Revisar
                                                                            </Button>
                                                                            <ReactTooltip />
                                                                        </p>
                                                                    )}
                                                                </CardActions>
                                                            ) : (
                                                                ''
                                                            )
                                                        }
                                                    </Card>
                                                </Grid>
                                                <Grid
                                                    container
                                                    item
                                                    xs={3}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    &nbsp;
                                                    <DatosResponsableFinanciero
                                                        estado={openModalReprFinan}
                                                        onClick={handleCerrarPopupDRF}
                                                        responsableFinanciero={representanteFinanciero}
                                                        rutPostulante={rut}
                                                        codigoNegocio={codigoNegocio}
                                                        carrera={codCarrera}
                                                        anioPromocion={anioPromocionParametro}
                                                        periodoPromocion={periodoPromocionParametro}
                                                        validado_={validadoRF}
                                                    />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {/*COMIENZO RL*/}
                                        {esMenorEdadParametro ? (
                                            <>
                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    <Card elevation={0}>
                                                        <div>
                                                            <b>
                                                                <span style={{ fontSize: 24 }}>
                                                                    Representante Legal
                                                                </span>
                                                            </b>
                                                            &nbsp;&nbsp;&nbsp;
                                                            {(validado || validadoRL) && !cargando_datosRL ? (
                                                                <CheckCircleOutline
                                                                    style={{ color: '#0062a1', fontSize: 30 }}
                                                                />
                                                            ) : (
                                                                ''
                                                            )}
                                                            <div style={{ color: 'gray', fontSize: '1rem' }}>
                                                                <div className="enrollment__subtitle">
                                                                    Es el representante legal del alumno al ser este un
                                                                    menor de edad, el cual se obliga a cumplir con las
                                                                    obligaciones legales contraídas con la
                                                                    Universidad.&nbsp;&nbsp;<br></br>
                                                                    <button
                                                                        style={{ fontSize: '1rem' }}
                                                                        type="button"
                                                                        className="btn btn-link"
                                                                        onClick={handleRequisitosRL}
                                                                    >
                                                                        Ver requisitos
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            {!cargando_datosRL ? (
                                                                representanteLegal[0].run === 0 ? (
                                                                    ''
                                                                ) : (
                                                                    <CardContent>
                                                                        <Grid container>
                                                                            <Grid item xs={12} sm={6} md={6}>
                                                                                <div className={classes.demo}>
                                                                                    <List dense>
                                                                                        {rLCmb.map((value) => {
                                                                                            const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                            if (
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !==
                                                                                                'NACIONALIDAD' &&
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !== 'SEXO'
                                                                                            ) {
                                                                                                return (
                                                                                                    <ListItem
                                                                                                        key={labelId}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[0]
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    marginTop:
                                                                                                                        -15,
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[1]
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </ListItem>
                                                                                                );
                                                                                            }
                                                                                        })}
                                                                                    </List>
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6} md={6}>
                                                                                <div className={classes.demo}>
                                                                                    <List dense>
                                                                                        {rLCmb2.map((value) => {
                                                                                            const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                            if (
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !== 'COMUNA' &&
                                                                                                value.Descripcion.split(
                                                                                                    ':',
                                                                                                )[0] !== 'TELÉFONO'
                                                                                            ) {
                                                                                                return (
                                                                                                    <ListItem
                                                                                                        key={labelId}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[0]
                                                                                                                }
                                                                                                            </p>
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    marginTop:
                                                                                                                        -15,
                                                                                                                    fontSize:
                                                                                                                        '1rem',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    value.Descripcion.split(
                                                                                                                        ':',
                                                                                                                    )[1]
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </ListItem>
                                                                                                );
                                                                                            }
                                                                                        })}
                                                                                    </List>
                                                                                </div>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </CardContent>
                                                                )
                                                            ) : (
                                                                <div style={{ textAlign: 'center', marginTop: 100 }}>
                                                                    <CircularProgress disableShrink />
                                                                    <br />
                                                                    <a>
                                                                        <span>Cargando datos Responsable Legal</span>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {
                                                            //codigoNegocioParametro === 1 ?
                                                            codigoNegocio === 1 ? (
                                                                <CardActions>
                                                                    {validadoAlum || validado ? (
                                                                        firmado1 || firmado2 ? (
                                                                            <p
                                                                                style={{ marginTop: 10 }}
                                                                                data-type={'light'}
                                                                                data-tip={
                                                                                    'No se pueden realizar cambios en Resp. Legal porque ya se firmó contrato'
                                                                                }
                                                                            >
                                                                                <Button
                                                                                    variant="contained"
                                                                                    style={{
                                                                                        padding: '6px 20px 6px 20px',
                                                                                        fontSize: '1rem',
                                                                                        backgroundColor:
                                                                                            'rgb(173 172 172)',
                                                                                        color: 'rgb(255 255 255)',
                                                                                    }}
                                                                                    disabled={true}
                                                                                    onClick={
                                                                                        handleDatosRepresentanteLegal
                                                                                    }
                                                                                >
                                                                                    Revisar
                                                                                </Button>
                                                                                <ReactTooltip />
                                                                            </p>
                                                                        ) : (
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    padding: '6px 20px 6px 20px',
                                                                                    fontSize: '1rem',
                                                                                    backgroundColor: '#0062a1',
                                                                                    color: 'White',
                                                                                }}
                                                                                onClick={handleDatosRepresentanteLegal}
                                                                            >
                                                                                Revisar
                                                                            </Button>
                                                                        )
                                                                    ) : (
                                                                        <p
                                                                            style={{ marginTop: 10 }}
                                                                            data-type={'light'}
                                                                            data-tip={
                                                                                'No se pueden guarar el Resp. Legal porque primero debe guardar el Alumno.'
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    padding: '6px 20px 6px 20px',
                                                                                    fontSize: '1rem',
                                                                                    backgroundColor: 'rgb(173 172 172)',
                                                                                    color: 'rgb(255 255 255)',
                                                                                }}
                                                                                disabled={true}
                                                                                onClick={
                                                                                    handleDatosRepresentanteFinanciero
                                                                                }
                                                                            >
                                                                                Revisar
                                                                            </Button>
                                                                            <ReactTooltip />
                                                                        </p>
                                                                    )}
                                                                </CardActions>
                                                            ) : (
                                                                ''
                                                            )
                                                        }
                                                    </Card>
                                                </Grid>
                                                <Grid
                                                    container
                                                    item
                                                    xs={3}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    &nbsp;
                                                    <DatosResponsableLegal
                                                        estado={openModalReprLeg}
                                                        onClick={handleCerrarPopupDRL}
                                                        responsableLegal={representanteLegal}
                                                        rutPostulante={rut}
                                                        codigoNegocio={codigoNegocio}
                                                        carrera={codCarrera}
                                                        anioPromocion={anioPromocionParametro}
                                                        periodoPromocion={periodoPromocionParametro}
                                                        validado_={validadoRL}
                                                    />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {/*FIN RL*/}

                                        {panelAsegurado && codigoNegocio == 1 ? (
                                            //codigoNegocioParametro
                                            representanteFinanciero[0].run === listaAsegurado[0].run &&
                                                calcularAños(listaAsegurado[0].fechaNacimiento) < 65 &&
                                                calcularAños(listaAsegurado[0].fechaNacimiento) > 17 ? (
                                                ''
                                            ) : (
                                                <>
                                                    <Grid
                                                        container
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="stretch"
                                                    >
                                                        <Card elevation={0}>
                                                            <div>
                                                                {/* <b><span style={{ fontSize: 24 }}>Asegurado</span></b>&nbsp;&nbsp;&nbsp;{(validado || validadoAseg) && !cargando_datosAse ? ((anoParametro === periodoActual) && (calcularAños(listaAsegurado[0].fechaNacimiento) < 75 && calcularAños(listaAsegurado[0].fechaNacimiento) > 17) ? <CheckCircleOutline style={{ color: '#0062a1', fontSize: 30 }} /> : (anoParametro !== periodoActual) ? <CheckCircleOutline style={{ color: '#0062a1', fontSize: 30 }} /> : "") : ""}
                                                                 */}
                                                                <b>
                                                                    <span style={{ fontSize: 24 }}>Asegurado</span>
                                                                </b>
                                                                &nbsp;&nbsp;&nbsp;
                                                                {(validado || validadoAseg) && !cargando_datosAse ? (
                                                                    calcularAños(listaAsegurado[0].fechaNacimiento) <
                                                                        75 &&
                                                                        calcularAños(listaAsegurado[0].fechaNacimiento) >
                                                                        17 ? (
                                                                        <CheckCircleOutline
                                                                            style={{ color: '#0062a1', fontSize: 30 }}
                                                                        />
                                                                    ) : validado ? (
                                                                        <CheckCircleOutline
                                                                            style={{ color: '#0062a1', fontSize: 30 }}
                                                                        />
                                                                    ) : (
                                                                        ''
                                                                    )
                                                                ) : (
                                                                    ''
                                                                )}
                                                                <div style={{ color: 'gray', fontSize: '1rem' }}>
                                                                    <div className="enrollment__subtitle">
                                                                        Se refiere al Padre, Madre o Tutor que sustenta
                                                                        económicamente las colegiaturas del alumno,
                                                                        quien debe cumplir con los requisitos de edad
                                                                        exigidos por la póliza. Si el sostenedor
                                                                        económico no cumple con los requisitos de edad,
                                                                        puede asegurar a otra persona.&nbsp;&nbsp;
                                                                        <button
                                                                            style={{ fontSize: '1rem' }}
                                                                            type="button"
                                                                            className="btn btn-link"
                                                                            onClick={handleRequisitos}
                                                                        >
                                                                            Ver requisitos
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                {!cargando_datosAse ? (
                                                                    listaAsegurado[0].run === 0 ? (
                                                                        ''
                                                                    ) : (
                                                                        <CardContent>
                                                                            <Grid container>
                                                                                <Grid item xs={12} sm={6} md={6}>
                                                                                    <div className={classes.demo}>
                                                                                        <List dense>
                                                                                            {aseguradoCmb.map(
                                                                                                (value) => {
                                                                                                    const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                                    return (
                                                                                                        <ListItem
                                                                                                            key={
                                                                                                                labelId
                                                                                                            }
                                                                                                        >
                                                                                                            <div>
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                        fontSize:
                                                                                                                            '1rem',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {
                                                                                                                        value.Descripcion.split(
                                                                                                                            ':',
                                                                                                                        )[0]
                                                                                                                    }
                                                                                                                </p>
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        marginTop:
                                                                                                                            -15,
                                                                                                                        fontSize:
                                                                                                                            '1rem',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {
                                                                                                                        value.Descripcion.split(
                                                                                                                            ':',
                                                                                                                        )[1]
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </ListItem>
                                                                                                    );
                                                                                                },
                                                                                            )}
                                                                                        </List>
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={6} md={6}>
                                                                                    <div className={classes.demo}>
                                                                                        <List dense>
                                                                                            {aseguradoCmb2.map(
                                                                                                (value) => {
                                                                                                    const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                                    return (
                                                                                                        <ListItem
                                                                                                            key={
                                                                                                                labelId
                                                                                                            }
                                                                                                        >
                                                                                                            <div>
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                        fontSize:
                                                                                                                            '1rem',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {
                                                                                                                        value.Descripcion.split(
                                                                                                                            ':',
                                                                                                                        )[0]
                                                                                                                    }
                                                                                                                </p>
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        marginTop:
                                                                                                                            -15,
                                                                                                                        fontSize:
                                                                                                                            '1rem',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {
                                                                                                                        value.Descripcion.split(
                                                                                                                            ':',
                                                                                                                        )[1]
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </ListItem>
                                                                                                    );
                                                                                                },
                                                                                            )}
                                                                                        </List>
                                                                                    </div>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </CardContent>
                                                                    )
                                                                ) : (
                                                                    <div
                                                                        style={{ textAlign: 'center', marginTop: 100 }}
                                                                    >
                                                                        <CircularProgress disableShrink />
                                                                        <br />
                                                                        <a>
                                                                            <span>Cargando datos Asegurado</span>
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <CardActions>
                                                                {validadoAlum || validado ? (
                                                                    firmado1 || firmado2 ? (
                                                                        <p
                                                                            style={{ marginTop: 10 }}
                                                                            data-type={'light'}
                                                                            data-tip={
                                                                                'No se pueden realizar cambios en Asegurado porque ya se firmó contrato'
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    padding: '6px 20px 6px 20px',
                                                                                    fontSize: '1rem',
                                                                                    backgroundColor: 'rgb(173 172 172)',
                                                                                    color: 'rgb(255 255 255)',
                                                                                }}
                                                                                disabled={true}
                                                                                onClick={handleAsegurado}
                                                                            >
                                                                                Revisar
                                                                            </Button>
                                                                            <ReactTooltip />
                                                                        </p>
                                                                    ) : (
                                                                        <Button
                                                                            variant="contained"
                                                                            style={
                                                                                representanteFinanciero[0].run ===
                                                                                    listaAsegurado[0].run
                                                                                    ? calcularAños(
                                                                                        listaAsegurado[0]
                                                                                            .fechaNacimiento,
                                                                                    ) > 64
                                                                                        ? {
                                                                                            padding:
                                                                                                '6px 20px 6px 20px',
                                                                                            fontSize: '1rem',
                                                                                            backgroundColor:
                                                                                                '#0062a1',
                                                                                            color: 'White',
                                                                                        }
                                                                                        : {
                                                                                            padding:
                                                                                                '6px 20px 6px 20px',
                                                                                            fontSize: '1rem',
                                                                                            backgroundColor:
                                                                                                'rgb(173 172 172)',
                                                                                            color: 'rgb(255 255 255)',
                                                                                        }
                                                                                    : {
                                                                                        padding: '6px 20px 6px 20px',
                                                                                        fontSize: '1rem',
                                                                                        backgroundColor: '#0062a1',
                                                                                        color: 'White',
                                                                                    }
                                                                            }
                                                                            disabled={
                                                                                representanteFinanciero[0].run ===
                                                                                    listaAsegurado[0].run
                                                                                    ? calcularAños(
                                                                                        listaAsegurado[0]
                                                                                            .fechaNacimiento,
                                                                                    ) > 64
                                                                                        ? false
                                                                                        : true
                                                                                    : false
                                                                            }
                                                                            onClick={handleAsegurado}
                                                                        >
                                                                            Revisar
                                                                        </Button>
                                                                    )
                                                                ) : (
                                                                    <p
                                                                        style={{ marginTop: 10 }}
                                                                        data-type={'light'}
                                                                        data-tip={
                                                                            'No se pueden guarar el Asegurado porque primero debe guardar el Alumno.'
                                                                        }
                                                                    >
                                                                        <Button
                                                                            variant="contained"
                                                                            style={{
                                                                                padding: '6px 20px 6px 20px',
                                                                                fontSize: '1rem',
                                                                                backgroundColor: 'rgb(173 172 172)',
                                                                                color: 'rgb(255 255 255)',
                                                                            }}
                                                                            disabled={true}
                                                                            onClick={handleDatosRepresentanteFinanciero}
                                                                        >
                                                                            Revisar
                                                                        </Button>
                                                                        <ReactTooltip />
                                                                    </p>
                                                                )}
                                                                {listaAsegurado[0].run === 0 ? (
                                                                    ''
                                                                ) : calcularAños(listaAsegurado[0].fechaNacimiento) <
                                                                    18 ? (
                                                                    <Alert variant="outlined" severity={'warning'}>
                                                                        Debe ser mayor de 18 años
                                                                    </Alert>
                                                                ) : calcularAños(listaAsegurado[0].fechaNacimiento) >
                                                                    74 ? (
                                                                    <Alert variant="outlined" severity={'warning'}>
                                                                        No cumple con los requisitos de
                                                                        ingreso/renovación, por favor cambiar el
                                                                        asegurado.
                                                                    </Alert>
                                                                ) : calcularAños(listaAsegurado[0].fechaNacimiento) >
                                                                    64 ? (
                                                                    <Alert variant="outlined" severity={'warning'}>
                                                                        De acuerdo a la información registrada, tu
                                                                        actual asegurado solo cuenta con la cobertura de
                                                                        fallecimiento, y no con la cobertura de
                                                                        invalidez 2/3, cuya edad máxima de permanencia
                                                                        es 65 años
                                                                    </Alert>
                                                                ) : (
                                                                    ''
                                                                )}
                                                                {/* {listaAsegurado[0].rut === 0 ? "" : calcularAños(listaAsegurado[0].fechaNacimiento) < 18 ? (anoParametro === periodoActual ? <Alert variant="outlined" severity={"warning"}>Debe ser mayor de 18 años</Alert> : "") : (calcularAños(listaAsegurado[0].fechaNacimiento) > 64 || calcularAños(listaAsegurado[0].fechaNacimiento) > 69) ? (anoParametro === periodoActual ? <Alert variant="outlined" severity={"warning"}>Debe ser menor de 65 años</Alert> : <Alert variant="outlined" severity={"warning"}>De acuerdo a la información registrada, tu actual asegurado solo cuenta con la cobertura de fallecimiento, y no con la cobertura de invalidez 2/3, cuya edad máxima de permanencia es 65 años</Alert>) : ""} */}
                                                            </CardActions>
                                                        </Card>
                                                    </Grid>
                                                    <Grid
                                                        container
                                                        item
                                                        xs={3}
                                                        direction="column"
                                                        justifyContent="center"
                                                        alignItems="stretch"
                                                    >
                                                        <AseguradoPopUp
                                                            estado={openModalAsegurado}
                                                            onClick={handleCerrarPopupAsegurado}
                                                            asegurado={listaAsegurado}
                                                            rutPostulante={rut}
                                                            codigoNegocio={codigoNegocio}
                                                            carrera={codCarrera}
                                                            anioPromocion={anioPromocionParametro}
                                                            periodoPromocion={periodoPromocionParametro}
                                                            validado_={validadoAseg}
                                                        />
                                                    </Grid>
                                                </>
                                            )
                                        ) : (
                                            ''
                                        )}

                                        {panelPC && codigoNegocio === 1 ? (
                                            //codigoNegocioParametro
                                            <>
                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    <Card elevation={0}>
                                                        <div>
                                                            <b>
                                                                <span style={{ fontSize: 24 }}>Contacto</span>
                                                            </b>
                                                            &nbsp;&nbsp;&nbsp;
                                                            {(validado || validadoCont) && !cargando_datosCont ? (
                                                                <CheckCircleOutline
                                                                    style={{ color: '#0062a1', fontSize: 30 }}
                                                                />
                                                            ) : (
                                                                ''
                                                            )}
                                                            <div style={{ color: 'gray', fontSize: '1rem' }}>
                                                                <div className="enrollment__subtitle">
                                                                    Persona a la que se debe contactar para resolver
                                                                    situaciones que, por su naturaleza, no pueden ser
                                                                    resueltas por o con el alumno. Puede ser distinto al
                                                                    responsable financiero.&nbsp;&nbsp;
                                                                </div>
                                                            </div>
                                                            {!cargando_datosCont ? (
                                                                listaContacto[0].run === 0 ? (
                                                                    ''
                                                                ) : (
                                                                    <CardContent>
                                                                        <Grid container>
                                                                            <Grid item xs={12} sm={6} md={6}>
                                                                                <div className={classes.demo}>
                                                                                    <List dense>
                                                                                        {contactoCmb.map((value) => {
                                                                                            const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                            return (
                                                                                                <ListItem key={labelId}>
                                                                                                    <div>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[0]
                                                                                                            }
                                                                                                        </p>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginTop:
                                                                                                                    -15,
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[1]
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </ListItem>
                                                                                            );
                                                                                        })}
                                                                                    </List>
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6} md={6}>
                                                                                <div className={classes.demo}>
                                                                                    <List dense>
                                                                                        {contactoCmb2.map((value) => {
                                                                                            const labelId = `checkbox-list-secondary-label-${value.ID}`;
                                                                                            return (
                                                                                                <ListItem key={labelId}>
                                                                                                    <div>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                color: 'rgba(0, 0, 0, 0.54)',
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[0]
                                                                                                            }
                                                                                                        </p>
                                                                                                        <p
                                                                                                            style={{
                                                                                                                marginTop:
                                                                                                                    -15,
                                                                                                                fontSize:
                                                                                                                    '1rem',
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                value.Descripcion.split(
                                                                                                                    ':',
                                                                                                                )[1]
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </ListItem>
                                                                                            );
                                                                                        })}
                                                                                    </List>
                                                                                </div>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </CardContent>
                                                                )
                                                            ) : (
                                                                <div style={{ textAlign: 'center', marginTop: 100 }}>
                                                                    <CircularProgress disableShrink />
                                                                    <br />
                                                                    <a>
                                                                        <span>Cargando datos Contacto</span>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <CardActions>
                                                            {validadoAlum || validado ? (
                                                                firmado1 || firmado2 ? (
                                                                    <p
                                                                        style={{ marginTop: 10 }}
                                                                        data-type={'light'}
                                                                        data-tip={
                                                                            'No se pueden realizar cambios en Contacto porque ya se firmó contrato'
                                                                        }
                                                                    >
                                                                        <Button
                                                                            style={{
                                                                                padding: '6px 20px 6px 20px',
                                                                                fontSize: '1rem',
                                                                                backgroundColor: 'rgb(173 172 172)',
                                                                                color: 'rgb(255 255 255)',
                                                                            }}
                                                                            disabled={true}
                                                                            onClick={handleContacto}
                                                                        >
                                                                            Revisar
                                                                        </Button>
                                                                        <ReactTooltip />
                                                                    </p>
                                                                ) : (
                                                                    <Button
                                                                        style={{
                                                                            padding: '6px 20px 6px 20px',
                                                                            fontSize: '1rem',
                                                                            backgroundColor: '#0062a1',
                                                                            color: 'White',
                                                                        }}
                                                                        disabled={false}
                                                                        onClick={handleContacto}
                                                                    >
                                                                        Revisar
                                                                    </Button>
                                                                )
                                                            ) : (
                                                                <p
                                                                    style={{ marginTop: 10 }}
                                                                    data-type={'light'}
                                                                    data-tip={
                                                                        'No se pueden guarar el Contacto porque primero debe guardar el Alumno.'
                                                                    }
                                                                >
                                                                    <Button
                                                                        variant="contained"
                                                                        style={{
                                                                            padding: '6px 20px 6px 20px',
                                                                            fontSize: '1rem',
                                                                            backgroundColor: 'rgb(173 172 172)',
                                                                            color: 'rgb(255 255 255)',
                                                                        }}
                                                                        disabled={true}
                                                                        onClick={handleDatosRepresentanteFinanciero}
                                                                    >
                                                                        Revisar
                                                                    </Button>
                                                                    <ReactTooltip />
                                                                </p>
                                                            )}
                                                        </CardActions>
                                                    </Card>
                                                </Grid>
                                                <Grid
                                                    container
                                                    item
                                                    xs={3}
                                                    direction="column"
                                                    justifyContent="center"
                                                    alignItems="stretch"
                                                >
                                                    <ContactoPopUp
                                                        estado={openModalContacto}
                                                        onClick={handleCerrarPopupContacto}
                                                        contacto={listaContacto}
                                                        rutPostulante={rut}
                                                        codigoNegocio={codigoNegocio}
                                                        carrera={codCarrera}
                                                        anioPromocion={anioPromocionParametro}
                                                        periodoPromocion={periodoPromocionParametro}
                                                        validado_={validadoCont}
                                                    />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        <Grid
                                            container
                                            item
                                            xs={4}
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="stretch"
                                        ></Grid>
                                        <div className="payment-webpay__submit" style={{ width: '100%' }}>
                                            <div className="form-group">
                                                {codigoNegocio === 1 ? (
                                                    <a
                                                        onClick={() => {
                                                            history.push({
                                                                pathname: '/instrucciones',
                                                                state: {
                                                                    rut: rut,
                                                                    codCarrera: codCarrera,
                                                                    codigoNegocio: codigoNegocio,
                                                                    codigoPlanificacionAcademica:
                                                                        codigoPlanificacionAcademicaParametro,
                                                                    codsede: sedeParametro,
                                                                    nombreCarrera: nombreCarreraParametro,
                                                                    nombreAlumno: nombreAlumnoParametro,
                                                                    numeroAlumno: numeroAlumnoParametro,
                                                                    anioPromocion: anioPromocionParametro,
                                                                    periodoPromocion: periodoPromocionParametro,
                                                                },
                                                            });
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                        /* href="pago-webpay--04.html" */ className="enrollment__back ml-5"
                                                    >
                                                        <svg className="svg-chevron-left-dims">
                                                            <use xlinkHref={f1 + '#chevron-left'}></use>
                                                        </svg>{' '}
                                                        Volver a Instrucciones / Etapas
                                                    </a>
                                                ) : (
                                                    ''
                                                )}
                                                <label className="submit-btn__label-disabled">
                                                    Ir a Formas de Pago
                                                </label>

                                                <button
                                                    className="btn btn-primary mr-5"
                                                    style={{ backgroundColor: '#0062a1' }}
                                                    type="submit"
                                                    disabled={
                                                        /* validado?false: (validadoAlum && validadoRF && ((anoParametro===periodoActual)&&(calcularAños(listaAsegurado[0].fechaNacimiento)<64 && calcularAños(listaAsegurado[0].fechaNacimiento)>18)?validadoAseg:representanteFinanciero[0].rut===listaAsegurado[0].rut?true:validadoAseg) && validadoCont ? false : true) */
                                                        /* validado ? false : (validadoAlum && validadoRF && ((anoParametro !== periodoActual) ? validadoAseg : ((anoParametro === periodoActual) && (calcularAños(listaAsegurado[0].fechaNacimiento) < 75 && calcularAños(listaAsegurado[0].fechaNacimiento) > 17) ? validadoAseg : false)) && validadoCont ? false : true)} */
                                                        // codigoNegocio === 1 ? (validado ? false : (validadoAlum && validadoRF && (esMenorEdadParametro ? validadoRL : true) && (panelAsegurado ? ((calcularAños(listaAsegurado[0].fechaNacimiento) < /* 65 */75 && calcularAños(listaAsegurado[0].fechaNacimiento) > 17) ? validadoAseg : false) : true) && (panelPC ? (validadoCont ? false : true) : true))) : false}
                                                        codigoNegocio === 1
                                                            ? validado
                                                                ? false
                                                                : validadoAlum &&
                                                                    validadoRF &&
                                                                    (esMenorEdadParametro ? validadoRL : true) &&
                                                                    validadoCont
                                                                    ? false
                                                                    : true
                                                            : false
                                                    }
                                                    onClick={() => {
                                                        if (codigoNegocio === 1) {
                                                            UpdateEtapaProceso();
                                                        } else {
                                                            onClickContinuar('3');
                                                        }
                                                    }}
                                                >
                                                    Continuar
                                                </button>
                                            </div>
                                        </div>
                                        {/* <Grid container item xs={4} direction="column" justifyContent="center" alignItems="stretch">
                                        

                                    </Grid> */}
                                    </Grid>
                                </div>
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', marginTop: 100 }}>
                                <CircularProgress disableShrink />
                                <br />
                                <a>
                                    <span>Cargando datos</span>
                                </a>
                            </div>
                        )}
                    </div>
                    <RequisitosRF estado={openModalRequisitosRF} onClick={handleCerrarPopUpRequisitosRF} />
                    <RequisitosRL estado={openModalRequisitosRL} onClick={handleCerrarPopUpRequisitosRL} />
                    <RequisitosAsegurado estado={openModalRequisitos} onClick={handleCerrarPopUpRequisitos} />
                </main>
            )}
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    );
};
